import { useQuery } from "react-query";

import { CommonQueryKeys } from "../../../../common/QueryKeys";
import getBenefitModels from "../../../repositories/getBenefitModels";
import { GetBenefitModelsDTO } from "../../../types/GetBenefitModelsDTO";

const useFindBenefitModels = ({ enabled = true }: { enabled?: boolean }) => {
  return useQuery<GetBenefitModelsDTO[], Error>(
    [CommonQueryKeys.BENEFIT_MODELS],
    getBenefitModels,
    {
      initialData: [],
      enabled,
    }
  );
};

export default useFindBenefitModels;
